<template>
  <v-btn @click="download" class="text-capitalize" plain rounded>
    <v-icon class="me-2">{{ icons.mdiDownload }}</v-icon>
    İndir
  </v-btn>
</template>

<script>
// Pinia
import { usePageStore } from "@/stores/pageHeader";

// Utils
import { postData } from "@utils";
import { useToast } from "vue-toastification/composition";

// Icons
import { mdiDownload } from "@mdi/js";

export default {
  setup() {
    const pageStore = usePageStore();
    const toast = useToast();

    const download = async () => {
      try {
        const data = {
          method: "vendorFormOperations",
          func: "downloadForms",
          startdate: pageStore.dateRange.start,
          enddate: pageStore.dateRange.end,
        };
        const response = await postData(data);

        if (response.error) {
          toast.error("İndirme işlemi başarısız oldu.", {
            position: "bottom-center",
          });
          return;
        }

        window.open(response.file, "_blank");
      } catch (e) {
        toast.error("İndirme işlemi sırasında bir hata oluştu.", {
          position: "bottom-center",
        });
      }
    };

    return {
      pageStore,
      download,
      // Icons
      icons: {
        mdiDownload,
      },
    };
  },
};
</script>
